import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Link, useSearchParams } from 'react-router-dom';
import { Loader2, UserX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import RegisterClassic from './register/RegisterClassic';
import RegisterMinimalCard from './register/RegisterMinimalCard';
import RegisterDarkGlass from './register/RegisterDarkGlass';

// See LoginPage.jsx — same dispatcher pattern for register variants.
const VARIANTS = {
  classic: RegisterClassic,
  modern:  RegisterMinimalCard,
  bold:    RegisterDarkGlass,
};

const RegisterPage = () => {
  const { t } = useTranslation('auth');
  const user = useSelector((state) => state.auth.user);
  const { siteConfig, loaded: configLoaded } = useSiteConfig();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  if (user) {
    return <Navigate to={returnTo || '/home'} replace />;
  }

  if (!configLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0a0a0a]">
        <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
      </div>
    );
  }

  if (siteConfig.registration_enabled === false) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#0a0a0a] px-4">
        <div className="text-center max-w-md">
          <div className="w-14 h-14 rounded-full bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center mx-auto mb-4">
            <UserX className="w-7 h-7 text-amber-500" />
          </div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{t('register.closed', 'Registration Closed')}</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{t('register.closedDesc', 'Registration is currently closed. Please check back later.')}</p>
          <Link to="/login" className="text-sm font-medium text-[var(--color-primary-600)] dark:text-[var(--color-primary-400)] hover:underline">{t('register.alreadyHaveAccount', 'Already have an account?')} {t('register.logInLink', 'Log in')}</Link>
        </div>
      </div>
    );
  }

  const Variant = VARIANTS[siteConfig.auth_theme] || RegisterClassic;
  return <Variant />;
};

export default RegisterPage;
